import { render, staticRenderFns } from "./SpOrderCommentCreate.vue?vue&type=template&id=2893a11b&scoped=true&"
import script from "./SpOrderCommentCreate.vue?vue&type=script&lang=js&"
export * from "./SpOrderCommentCreate.vue?vue&type=script&lang=js&"
import style1 from "./SpOrderCommentCreate.vue?vue&type=style&index=1&id=2893a11b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2893a11b",
  null
  
)

export default component.exports